import { Helmet } from "react-helmet-async";

// Minimal runtime title/description updater for client-side SPA navigation.
// Full per-route SEO (keywords, canonical, hreflang, OG, Twitter, JSON-LD)
// is baked into the served static HTML at build time by scripts/prerender-seo.js.
// The home pages (HomeEN/HomeUA/HomeUKR) additionally set rich <Helmet> tags
// inline for runtime navigation.
export default function PageMeta({ title, description }) {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
    </Helmet>
  );
}
